<template>
    <div :class="[`border-${borderStyle}`, mergedClass]" />
</template>

<script setup>
import { twMerge } from "tailwind-merge";
import { computed } from "vue";

const props = defineProps({
    borderStyle: {
        type: String,
        default: "solid",
    },
    dividerClass: {
        type: String,
        default: "",
    },
});

const mergedClass = computed(() =>
    twMerge("border-b w-full border-gray-100", props.dividerClass)
);
</script>
